import React, {useState} from 'react';
import { Routes, Route } from "react-router-dom";
import LogIn from '../pages/LogIn';
import Main from '../pages/Main';
import AppLayout from '../features/AppLayout';
import SignUp from '../pages/SignUp';
import Profile from '../pages/Profile';
import PrivateRoute from './PrivateRoute';
import HistoricalTrend from '../pages/HistoricalTrend';

interface DeviceDataType {
  deviceId: string;
  temperature: number;
  humidity: number;
  resistance: number;
  updatedAt: string;
}

function App() {
  const [deviceDateArr, setDeviceDateArr] = useState<DeviceDataType[] | null>(null);
  console.log("Device Data:", deviceDateArr); // Debugging output
  return (
    <AppLayout>
      <Routes>
      <Route path="/login" element={  <LogIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/" element={<PrivateRoute><Main setDeviceDateArr={setDeviceDateArr} /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route 
        path="/historicaltrend" 
        element={<PrivateRoute><HistoricalTrend deviceData={deviceDateArr ?? undefined} /></PrivateRoute>} 
      />
      </Routes>
    </AppLayout>
   
  );
}

export default App;
